import { Box, Modal } from '@mui/material';
import React from 'react';
import { ModalWrapper } from '../Wrappers/ModalWrapper';
import { ButtonOutlined } from '../Buttons/ButtonOutlined';
import { TMaterialStyles } from '../../theme';
import { TIllustration } from '../Illustration';
import TypographyWithShadow from '../Typography/TypographyWithShadow';

interface IConfirmModal {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  closeButtonTitle?: string;
  submitButtonTitle?: string;
  onSubmit?: () => void;
  backgroundIllustrationName?: TIllustration;
  titleSize?: string;
}

export const ConfirmModal: React.FC<IConfirmModal> = ({
  isOpen,
  onClose,
  title,
  subtitle,
  closeButtonTitle,
  submitButtonTitle,
  onSubmit,
  backgroundIllustrationName,
  titleSize = 32,
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalWrapper
        contentWrappperSx={materialStyles.contentWrapper}
        onClose={onClose}
        backgroundIllustrationName={backgroundIllustrationName}
      >
        <TypographyWithShadow
          shadowType="DARK"
          sx={{ ...materialStyles.modalTitle, fontSize: titleSize }}
        >
          {title}
        </TypographyWithShadow>
        <TypographyWithShadow
          shadowType="DARK"
          sx={materialStyles.modalSubtitle}
        >
          {subtitle}
        </TypographyWithShadow>
        <Box sx={materialStyles.buttonsContainer}>
          <ButtonOutlined shadowType="DARK" onClick={onSubmit}>
            {submitButtonTitle}
          </ButtonOutlined>
          <ButtonOutlined shadowType="DARK" onClick={onClose}>
            {closeButtonTitle}
          </ButtonOutlined>
        </Box>
      </ModalWrapper>
    </Modal>
  );
};

const materialStyles: TMaterialStyles = {
  contentWrapper: {
    paddingTop: '53px',
    px: '29px',
    paddingBottom: '21px',
  },
  modalTitle: {
    fontSize: '32px',
    lineHeight: '100%',
    fontFamily: 'Rubber Duck !important',
    textAlign: 'center',
  },
  modalSubtitle: {
    fontSize: '13px',
    lineHeight: '100%',
    marginTop: '17px',
    textAlign: 'center',
    fontWeight: '600',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '26px',
    mx: '16px',
  },
};
